import { FeeLabelPDF } from './components/FeeLabelPDF';
import type { PriceSummaryData } from './types';

export function LateCancellationFeeDetailsPDF({
  data,
}: {
  data?: PriceSummaryData | null;
}) {
  return (
    <>
      <FeeLabelPDF label="Fee Type" value={data?.late_cancellation_fee_type} />
      <FeeLabelPDF
        label="Scheduled Pickup At"
        value={data?.scheduled_pickup_at}
      />
      <FeeLabelPDF
        label="Cancelled At"
        value={`${data?.canceled_at} (${data?.minutes_before_pickup} minutes before pickup)`}
      />
    </>
  );
}
